import {inject, observer} from 'mobx-react';
import './index.scss';
@inject(({store}) => ({
    voucherShow: store.voucherShow,
    changeVoucherShow: store.changeVoucherShow,
    vouchers: store.vouchers,
    jump: store.jump
}))
@observer
class Rules extends React.Component {
    viewMore() {
        this.props.jump('//touch.dujia.qunar.com/pg/zt/shucu/brand?type=browser');
    }

    render() {
        const {voucherShow, changeVoucherShow, vouchers} = this.props;
        if(!voucherShow) return null;
        return(
            <div className="voucher-modal">
                <div className="voucher-content">
                    <div className="voucher-tit">店铺联盟礼包</div>
                    <div className="voucher-detail">
                        {
                            vouchers.map(item => {
                                const {reduceAmount, amount} = item;

                                return (
                                    <div className="voucher-item">
                                        <div className="left">
                                            <i class="ico">￥</i>
                                            {reduceAmount}
                                        </div>
                                        <div className="right">
                                            <p className="title">度假满减券</p>
                                            <p className="desc">多店通用满{amount}可用</p>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="view-more" onClick={this.viewMore.bind(this)}>
                        <img src="//s.qunarzz.com/vacation_tuan/2020/06_shuchu/receive_success_v2.png" alt=""/>
                    </div>
                    <div className="close yo-ico" onClick={() => {
                        changeVoucherShow(false);
                    }}></div>
                </div>

            </div>
        );
    }
}

export default Rules;